import BoasVindasGestaoOrcamentariaView from "../../components/gestaoOrcamentaria/BoasVindasGestaoOrcamentariaView";

export default function BoasVindas() {
  return <BoasVindasGestaoOrcamentariaView />;
}
